import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import VideoList from "../../Components/VideoList/VideoList";
import Footer from "../../Components/Common/Footer";

class VideoListPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <VideoList />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default VideoListPage;
